import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
	isLoadingNews, newsAnnouncements, newsAudiences, newsAudiencesFailed, newsFilters, newsListFailed,
} from "./@signals"

const BASE = `${BACKEND_APIS.ANNOUNCEMENTS}/admin`

// @ui-seeker/utils has no PUT / PATCH; same contract as its helpers (200 or throw)
const jsonSubmit = (method, url, data) => fetch(url, {
	method, body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' },
}).then(res => {
	if (res.status !== 200) throw res
	return res.json()
})

// Untouched filters are left out: the API reads a missing param as "no filter"
const activeParams = ({ company, uid, state }) => Object.fromEntries(Object.entries({
	company, uid, state: state === 'all' ? null : state,
}).filter(([, value]) => value !== null && value !== undefined && value !== ''))

export function fetchNewsAnnouncements() {
	const params = activeParams(newsFilters.value)
	isLoadingNews.value = true
	return getSubmit(BASE, Object.keys(params).length ? params : null)
		.then(res => {
			newsAnnouncements.value = res?.data ?? []
			newsListFailed.value = false
		})
		.catch(() => { newsListFailed.value = true })
		.finally(() => { isLoadingNews.value = false })
}

export function fetchNewsAudiences() {
	return getSubmit(`${BASE}/audiences`)
		.then(res => {
			newsAudiences.value = { companies: res?.companies ?? [], users: res?.users ?? [] }
			newsAudiencesFailed.value = false
		})
		.catch(() => { newsAudiencesFailed.value = true })
}

// The listing leaves the HTML out, so the editor asks for the one it opens
export const fetchNewsAnnouncement = id => getSubmit(`${BASE}/${id}`)

// Create without an id, full replace with one (the PUT takes every field)
export const saveNewsAnnouncement = (payload, id = null) =>
	(id ? jsonSubmit('PUT', `${BASE}/${id}`, payload) : postSubmit(BASE, payload)).then(fetchNewsAnnouncements)

export const setNewsActive = (id, active) => jsonSubmit('PATCH', `${BASE}/${id}`, { active }).then(fetchNewsAnnouncements)

export const deleteNewsAnnouncement = id => deleteSubmit(`${BASE}/${id}`).then(fetchNewsAnnouncements)
